import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import AlertModal from 'web/components/AlertModal';
import { myOffersOnInvApi } from 'redux/actions/postInventory';
import MyBids from './MyBids';

const MyOfferInventoryBids = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');

    let toDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 31);
    toDate.setDate(toDate.getDate() + 31);
    const [pagevalues, setPageValues] = useState({
        filterByDelivery: "ALL",
        filterByStatus: "ALL",
        fromDate: fromDate.toISOString().substring(0, 10),
        toDate: toDate.toISOString().substring(0, 10),
    })

    // page data
    const [myOffersOnInvData, setMyOffersOnInvData] = useState();

    // alert modal related states
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    useEffect(() => {
        fetchMyAPI()
        window.scrollTo(0, 0);
    }, []);

    const fetchMyAPI = async (filterData) => {
        let data = {
            authId: localStorage.getItem('authId'),
            locationId: localStorage.getItem('locationID'),
            filterBy: filterData?.filterByStatus || pagevalues.filterByStatus,
            shippingMode: filterData?.filterByDelivery || pagevalues.filterByDelivery,
            startDate: filterData?.fromDate || pagevalues.fromDate,
            endDate: filterData?.toDate || pagevalues.toDate
        }
        let response = await dispatch(myOffersOnInvApi(data, token));
        if (response.success) {
            setMyOffersOnInvData(response.data)
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else if (response.data?.error?.message === 'No records found.') {
                setMyOffersOnInvData([])
            } else {
                setModalContent(response.data?.error?.message || 'Something went wrong, please try again in sometime.');
                setModalLink("");
                toggleModal();
            }
        }

    }

    return (<>
        <Helmet title="View The Offers You've Made for Pallet Inventory | PalletTrader" >
            <meta name="description"
                content="Keep track of your offers on pallet inventory. Stay informed about your listed items and manage your pallet procurement activity efficiently on our marketplace." />
            <meta name="robots" content="index,follow" />
            <link rel="canonical" href="https://www.pallettrader.com/view-my-offers-on-pallet-inventory" />
        </Helmet>
        <MyBids
            myOffersOnInvData={myOffersOnInvData}
            type={'bidsPalletOffers'}
            activeSearch={'PostInventory'}
            expanded={'panel1'}
            activePage={'PostInventory'}
            callBackFun={(data) => fetchMyAPI(data)} />

        <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={''}
            content={modalContent}
            link={modalLink}
        /></>
    )
};

export default MyOfferInventoryBids;